import { Navigate } from "react-router-dom";
import { ROUTES } from "../../lib/constants.js";
import { useUser } from "../UserContext.js";

export default function EmployeeRoute({ children }) {
  const { isEmployee, runId } = useUser();

  if (isEmployee) {
    return children;
  }

  return <Navigate to={ROUTES.BASE.replace(":id", runId)} replace />;
}
